import { render } from "./EmailPanel.vue?vue&type=template&id=4076d1dc&scoped=true"
import script from "./EmailPanel.vue?vue&type=script&lang=js"
export * from "./EmailPanel.vue?vue&type=script&lang=js"

import "./EmailPanel.vue?vue&type=style&index=0&id=4076d1dc&lang=scss&scoped=true"
import "./EmailPanel.vue?vue&type=style&index=1&id=4076d1dc&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4076d1dc"]])

export default __exports__